import {
  CONTRACT_ADMIN_ROLE_ID,
  CONTRACT_FINANCE_USER_TYPE_ID,
  CONTRACT_TECHNICAL_USER_TYPE_ID
} from "~/constants/contract/roleType";


const contractUserMixin = {
  methods: {
    getContractRoleName(roleId) {
      const roles = {
        [CONTRACT_ADMIN_ROLE_ID]: this.$t("user.contract.role.administrator"),
        [CONTRACT_TECHNICAL_USER_TYPE_ID]: this.$t("user.contract.role.technical_user"),
        [CONTRACT_FINANCE_USER_TYPE_ID]: this.$t("user.contract.role.finance_user")
      };

      return roles[roleId] || '';
    },
    getContractUser(contractId, userId) {
      return this.$store.getters["contract/currentUser"](contractId, userId);
    },
    isUserInContract(contractId, userId) {
      if (!contractId || !userId) {
        return false;
      }
      const contract = this.$store.getters["contract/getContract"](contractId);
      if (!contract || !contract.users) {
        return false;
      }
      return contract.users.some(user => user.id === userId);
    },
  }
};
//
export default contractUserMixin;